<template>
  <div class="vue-order-line-item col-12">
    <div class="row mt-4 mb-5 px-3">
      <div class="col-12 divider-col">
        <div class="divider"></div>
      </div>
    </div>
    <div class="row d-flex align-items-center px-3">
      <div class="col-xl-2 col-md-4 col-3">
        <img :src="item.image_url" :alt="item.name">
      </div>

      <div class="col-xl-5 col-md-8 col-9">
        <h5 class="item-title">{{ item.name }}</h5>
        <span class="meta-info">{{ item.description }}</span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "OrderGiftItem",

  mounted() {
    console.log(this.item);
  },

  props: {
    item: {
      type: Object,
      required: true,
    }
  },
}
</script>
